import { ERROR_MESSAGE } from '@/js/helpers/globalConst';

const getError = (errorCode, errorMessage, constErrorsList = {}) => ({
  code: errorCode,
  message: constErrorsList && constErrorsList[errorCode]
    ? constErrorsList[errorCode] : errorMessage,
});

/**
 * Преобразование к одному виду ошибок
 * @param {Object} data - ответ от бекенда
 * @param {Object} [constErrorsList={}] - коды ошибок с текстовым описанием
 * @returns {[]}
 */
const formattedError = (data, constErrorsList = {}) => {
  const itemsError = [];
  if (data.ERRORS) {
    data.ERRORS.ITEMS.forEach((item) => {
      itemsError.push(getError(item.CODE, item.TITLE, constErrorsList));
    });
  } else if (data.errors) {
    data.errors.forEach((item) => {
      itemsError.push(getError(item.code, item.message, constErrorsList));
    });
  }
  if (!itemsError.length) {
    const code = data.CODE ? String(data.CODE) : '0';
    const message = code !== '0' || data.MESSAGE ? data.MESSAGE : ERROR_MESSAGE;
    itemsError.push({
      code,
      message,
    });
  }
  return itemsError;
};

export default formattedError;
